<template>
	<div v-if="show && dataFilled" :class="slideInClass">
		<header>
			<div class="title-container">
				<div>
					<h4>
						<span v-if="title">{{ title }}</span>
						<Label v-else-if="characteristic" :characteristic="characteristic"/>
						<template v-if="supplements">({{ supplements }})</template>
					</h4>
				</div>
				<div class="close-container">
					<a href="#" @click.prevent="closeFan(false)">
						<Icon icon="close"/>
					</a>
				</div>
			</div>
		</header>
		<main class="scrollbar-check">
			<Edit
				:item="item"
				:experience-config="experienceConfig"
				:self-assessment-config="selfAssessmentConfig"
				:education-config="educationConfig"
				:type="type"
				@change="onAdditionChange"
			/>
			<div v-if="type === 'application'" class="characteristic-addition-fan--info">
				<NoExperienceInfo />
			</div>
		</main>
		<footer>
			<Button
				text="OK"
				:disabled="!valid"
				icon="checkmark"
				@click="closeFan(true)"
			/>
		</footer>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {mapActions, mapState} from "vuex";
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/characteristic/addition/fan";
import Label from "@/vue/characteristic/Label.vue";
import Edit from "@/vue/characteristic/addition/Edit.vue";
import NoExperienceInfo from "@/vue/application/characteristic/NoExperienceInfo.vue";
import {getAsList} from "@/helper/characteristic/Supplement";

export default {

	components: {
		Edit,
		Label,
		Button,
		Icon,
		NoExperienceInfo,
	},

	data ()
	{
		return {
			dataFilled: false,
			experience: undefined,
			selfAssessment: undefined,
			educationsFinished: undefined,
			educationsUnfinished: undefined,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		...mapState('characteristic/addition/fan', [
			'show',
			'characteristic',
			'type',
			'title',
			'item',
			'experienceConfig',
			'selfAssessmentConfig',
			'educationConfig',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in', 'characteristic-addition-fan']
			});
		},
		supplements ()
		{
			if (!this.item.supplements)
			{
				return undefined;
			}

			return getAsList(this.item.supplements);
		},
		withExperience ()
		{
			return this.experienceConfig?.enabled === true;
		},
		withSelfAssessment ()
		{
			return this.selfAssessmentConfig?.enabled === true;
		},
		withEducation ()
		{
			return this.educationConfig?.enabled === true;
		},
		experienceValid ()
		{
			return !this.withExperience || this.experience !== undefined;
		},
		selfAssessmentValid ()
		{
			return !this.withSelfAssessment || this.selfAssessment !== undefined;
		},
		educationValid ()
		{
			if (!this.withEducation)
			{
				return true;
			}

			return this.educationsFinished !== undefined && this.educationsUnfinished !== undefined;
		},
		valid ()
		{
			return this.experienceValid
				&& this.selfAssessmentValid
				&& this.educationValid;
		},
	},

	methods: {
		...mapActions('characteristic/addition/fan', [
			'close',
		]),
		closeFan (confirmed)
		{
			let data = {
				confirmed
			};

			if (confirmed)
			{
				if (this.withExperience)
				{
					data.experience = this.experience;
				}

				if (this.withSelfAssessment)
				{
					data.selfAssessment = this.selfAssessment;
				}

				if (this.withEducation)
				{
					data.educationsFinished = this.educationsFinished;
					data.educationsUnfinished = this.educationsUnfinished;
				}
			}

			this.close(data);

			Object.assign(this.$data, this.$options.data.apply(this));
		},
		onAdditionChange (data)
		{
			this.experience = data.experience;
			this.selfAssessment = data.selfAssessment;
			this.educationsFinished = data.educationsFinished;
			this.educationsUnfinished = data.educationsUnfinished;
		},
		getEducations (educations)
		{
			return educations !== undefined
				? _.map(educations, education =>
				{
					return {item: education};
				})
				: undefined;
		}
	},

	watch: {
		item (item)
		{
			if (!item)
			{
				return;
			}

			this.experience = item.experience;
			this.selfAssessment = item.selfAssessment;
			this.educationsFinished = this.getEducations(item.educationsFinished);
			this.educationsUnfinished = this.getEducations(item.educationsUnfinished);

			this.dataFilled = true;
		}
	}
}
</script>
